
export default function logger() {

  console.debug('Init logger...');

  var oldConsoleLog = null;
  var pub = {};

  pub.enableLogger =  function enableLogger() {
    if(oldConsoleLog == null)
      return;

    window['console']['log'] = oldConsoleLog;
  };

  pub.disableLogger = function disableLogger() {
    oldConsoleLog = console.log;
    window['console']['log'] = function() {};
  };

  return pub;
};
